import { STORAGE_KEYS } from "./config.mjs";

export class ReceiptStore {
  constructor(storage) {
    this.storage = storage;
  }

  list() {
    try {
      const parsed = JSON.parse(this.storage.getItem(STORAGE_KEYS.receipts));
      return Array.isArray(parsed) ? parsed.filter(validReceipt) : [];
    } catch {
      return [];
    }
  }

  latest(kind) {
    return this.list().find((receipt) => !kind || receipt.kind === kind) ?? null;
  }

  add(receipt) {
    if (!validReceipt(receipt)) throw new TypeError("cannot persist unconfirmed receipt");
    const next = [structuredClone(receipt), ...this.list()
      .filter((prior) => prior.txHash !== receipt.txHash)].slice(0, 20);
    this.storage.setItem(STORAGE_KEYS.receipts, JSON.stringify(next));
    return receipt;
  }
}

export function validReceipt(receipt) {
  return Boolean(
    receipt
    && ["send", "checkout"].includes(receipt.kind)
    && /^[0-9A-F]{64}$/.test(receipt.txHash)
    && /^[1-9][0-9]*$/.test(receipt.height)
    && receipt.code === 0
    && typeof receipt.confirmedAt === "string",
  );
}

export function confirmedReceipt(inclusion, details) {
  const txHash = String(inclusion?.txhash ?? inclusion?.txHash ?? "").toUpperCase();
  const height = String(inclusion?.height ?? "");
  const code = Number(inclusion?.code);
  const receipt = {
    ...details,
    txHash,
    height,
    code,
    result: inclusion?.raw_log || inclusion?.rawLog || "success",
    confirmedAt: new Date().toISOString(),
  };
  if (!validReceipt(receipt)) {
    throw new Error(`transaction was not confirmed successfully (code ${Number.isFinite(code) ? code : "unknown"})`);
  }
  return Object.freeze(receipt);
}
